module.exports = __webpack_public_path__ + "img/img_series_115.e0c48392.png";